// ------------------------------------
// Constants
// ------------------------------------
export var UPDATE_MAP_HISTORY = "UPDATE_MAP_HISTORY";

// ------------------------------------
// Actions
// ------------------------------------

var updateHistory = function updateHistory(lastZoomLevel, lastMapCenter) {
  return {
    type: UPDATE_MAP_HISTORY,
    payload: {
      lastZoomLevel: lastZoomLevel,
      lastMapCenter: lastMapCenter
    }
  };
};

// ------------------------------------
// Action creators
// ------------------------------------
var updateMapHistory = function updateMapHistory(lastZoomLevel, lastMapCenter) {
  return function (dispatch) {
    dispatch(updateHistory(lastZoomLevel, lastMapCenter));
  };
};

export var actions = {
  updateMapHistory: updateMapHistory
};

// ------------------------------------
// Reducer
// ------------------------------------
var initialState = {
  lastZoomLevel: undefined,
  lastMapCenter: undefined
};

var mapHistoryReducer = function mapHistoryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case UPDATE_MAP_HISTORY:
      return Object.assign({}, state, {
        lastMapCenter: action.payload.lastMapCenter,
        lastZoomLevel: action.payload.lastZoomLevel
      });
    default:
      return state;
  }
};

export default mapHistoryReducer;